export default {
    getters: {
        getFactoryGroupList: function() {
            return ['인쇄', '조판', '코팅', '톰슨', '접착', '박', '에폭시', '임가공', '원단', '재단', '접지', '기타']
        },
        getOrderMethodList: function() {
            return ['택배', '다마스', '오토바이', '용달', '화물', '직배송', '기타']
        },
        getProductCategoryList: function() {
            return ['쇼핑백', '박스', '비닐봉투', '에코백', '서류봉투', '스티커', '리플렛', '책자', '명함', '실크인쇄', '기타 인쇄물']
        },
        getCommonRefreshInterval: function() {
            return 60000
        },
        getApiRequestTimeLimit: function() {
            return 10000
        }
    }
}